/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IMedicine } from 'app/shared/model/medicine.model';
import { IMedicationDetails } from 'app/shared/model/medication-details.model';
import { IMedicationSchedule } from 'app/shared/model/medication-schedule.model';

export interface IMedicationScheduleDetails {
  id?: string;
  dose?: string;
  active?: boolean;
  timestampentry?: number;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
  glucoUser?: IGlucoUser;
  medicine?: IMedicine;
  medication?: IMedicationDetails;
  schedule?: IMedicationSchedule;
}

export const defaultValue: Readonly<IMedicationScheduleDetails> = {
  active: false,
};
